export var completeStageSuccess = function completeStageSuccess(message, t) {
  return {
    severity: 'success',
    message: t(message),
    duration: 'medium'
  };
};
export var unknownFailure = function unknownFailure(t) {
  return {
    severity: 'error',
    message: t('The stage could not be completed at this time. Try again later.'),
    duration: 'medium'
  };
};
export var completeStageFailure = function completeStageFailure(t) {
  return {
    severity: 'error',
    message: t('The stage could not be completed at this time. Try again later.'),
    duration: 'medium'
  };
};
export var completeStageFailureWithMessage = function completeStageFailureWithMessage(message) {
  return {
    severity: 'error',
    message: message,
    duration: 'medium'
  };
};
export var limitReachedFailure = function limitReachedFailure(t) {
  return {
    severity: 'error',
    message: t("The stage could not be completed because this challenge has been completed by enough other members to reach the challenge's completion limit. Please try a different challenge."),
    duration: 'medium'
  };
};